import React, { Component } from "react";
import Button from "../../../components/bases/button/button.js";
import Dialog from "../../dialogs/dialog.js";
import Tooltip from "../../../components/bases/tooltips/tooltip.js";
import ConfManager from "./confmanager.js";
import { GlobalContext } from "../../../utils/globalprovider.js";




class DialogSelectConf extends Dialog
{
    static contextType = GlobalContext;
  constructor(props) 
  {
    super(props);

    
    this.state.title = "";
    this.state.displayform = false;
    this.state.formaction = ""; // add / edit / remove 
    this.state.formulaire = {}
    


    var buttons = [];
  
    buttons.push({type:"back", disabled:false});

    this.state.buttons = buttons;

    this.handleButton =  this.handleButton.bind(this);
    this.handleSelectButton = this.handleSelectButton.bind(this);
    this.onQuit = this.onQuit.bind(this)


   
  }

  handleButton(buttonkey)
  {
    switch (buttonkey)
    {
        case "back":
          this.onQuit();
          break;
    }
  }


  onQuit()
  {
      this.props.onvalidform({ret:false})
  }

  onValid()
  {
    alert ("on valide");
  }

  componentDidMount()
  {
    super.componentDidMount();
    const title = {fr:"Sélectionner une configuration",  en:"Select a configuration",}
    this.setState ({title: title})

  }


  handleSelectButton(datas)
  {

      this.props.onvalidform({ret:true, datas: datas})
  }

  render()
  {


    var maxwidth =  (window.innerWidth * 20)/100;
    if (maxwidth > 400) maxwidth = 400;

    var maxheight =  (window.innerHeight * 75)/100;
    if (maxheight > 400) maxheight = 400;



    var localrender =(
      <>
                
            <div className="table-limit" style={{width:maxwidth, height:maxheight}}>
                            <ConfManager
                                codatas = {this.props.conf}
                                action = "select"
                                onselect = {this.handleSelectButton}
                            />


            </div>          
                

      </>          
      );



    return super.render(localrender);
  }


}
DialogSelectConf.defaultProps = 
{
    conf: {coid:0},
    onvalidform: null,
    closebutton: true,
}

export default DialogSelectConf;